export default "__VITE_ASSET__40964cc6__"